var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 61,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_22684_71392",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 45,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1187 52.1125H18.7857C18.4173 52.1125 18.118 51.8132 18.118 51.4448V43.4786C18.118 43.1102 17.8187 42.8109 17.4503 42.8109H9.48409C9.11571 42.8109 8.81641 42.5116 8.81641 42.1432V34.9713C8.81641 34.603 9.11571 34.3037 9.48409 34.3037H24.3804C25.7043 34.3037 26.7749 35.3743 26.7749 36.6981V51.4448C26.7864 51.8247 26.4871 52.1125 26.1187 52.1125ZM8.82791 12.9607C8.82791 10.6698 10.6813 8.81641 12.9722 8.81641H30.4702C42.3735 8.81641 52.124 18.5669 52.124 30.4702C52.124 42.3735 42.3735 52.124 30.4702 52.124H30.4357L34.8332 47.7265C35.6275 46.9322 36.0765 45.8501 36.0765 44.7104V28.7089C36.0765 26.6713 34.4303 25.0251 32.3927 25.0251H16.3912C15.263 25.0251 14.1809 25.4741 13.3751 26.2684L8.81641 30.8271V12.9607H8.82791Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_22684_71392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1242 8.81641H8.82812V52.124H52.1242V8.81641Z",
    fill: "url(#paint0_linear_22684_71392)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22684_71392",
    x1: 13.9023,
    y1: 49.4774,
    x2: 42.1524,
    y2: 17.0831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00368B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppicon);
export default __webpack_public_path__ + "static/media/appicon.031d4064dbcd5185195fe0fee40dbbe0.svg";
export { ForwardRef as ReactComponent };